export default {
  'usage.title': 'Usage Dashboard',
  'usage.subtitle': 'Filterable plan consumption, operations, documents, AI and organization',
  'usage.refresh': 'Refresh',
  'usage.filters.title': 'Filters',
  'usage.filters.environment': 'Environment',
  'usage.filters.environment.all': 'All environments',
  'usage.filters.dates': 'Date range',
  'usage.filters.process': 'Process',
  'usage.filters.agent': 'AI agent',
  'usage.filters.user': 'User',
  'usage.filters.userHint':
    'User: meaning depends on the card (applicant, assignee, owner or creator).',
  'usage.filters.agentRpaHint': 'This filter only applies to AI agents, not RPA.',
  'usage.filters.invalidRange': 'Invalid date range (max 366 days; dateTo > dateFrom).',
  'usage.filters.apply': 'Apply',
  'usage.filters.reset': 'Reset',
  'usage.filters.clearAll': 'Clear all',

  'usage.scope.company': 'Company',
  'usage.scope.environment': 'Environment',
  'usage.scope.process': 'Process',
  'usage.scope.agent': 'Agent',
  'usage.scope.user': 'User',

  'usage.context.title': 'You are viewing consumption of:',
  'usage.context.allCompany': 'Whole company',

  'usage.metric.applied': 'Honors your filters',
  'usage.metric.notApplied': 'Filter not applied: {filters}',
  'usage.metric.filter.dateFrom': 'From',
  'usage.metric.filter.dateTo': 'To',
  'usage.metric.filter.environmentIds': 'Environment',
  'usage.metric.filter.processIds': 'Process',
  'usage.metric.filter.agentIds': 'AI agent',
  'usage.metric.filter.userIds': 'User',
  // Singular keys kept for older envelopes during rollout
  'usage.metric.filter.environmentId': 'Environment',
  'usage.metric.filter.processId': 'Process',
  'usage.metric.filter.agentId': 'AI agent',
  'usage.metric.filter.userId': 'User',

  'usage.plan.title': 'Your plan',
  'usage.plan.requests': 'Requests',
  'usage.plan.documents': 'Generated documents',
  'usage.plan.storage': 'Storage',
  'usage.plan.emails': 'Emails',
  'usage.plan.entities': 'Dynamic entities',
  'usage.plan.ai': 'AI consumption',
  'usage.plan.aiCredits': 'Credits available: {value}',
  'usage.plan.of': 'of {total}',
  'usage.plan.unlimited': 'Unlimited',
  'usage.plan.pending': 'Computed once detail loads',
  'usage.plan.warn': 'Near limit',
  'usage.plan.over': 'Over plan',

  'usage.section.planUsage': 'Plan & consumption',
  'usage.section.planUsage.subtitle':
    'Period usage against contracted limits, per consumption type',
  'usage.section.planUsage.subtitle.filtered':
    'Consumption of your selection (process / agent / user) against total plan limits',
  'usage.section.consumption': 'Usage by consumption type',
  'usage.section.requests': 'Requests',
  'usage.section.requests.subtitle': 'ProcessInstances in the period',
  'usage.section.operations': 'Operations',
  'usage.section.bulk': 'Bulk requests',
  'usage.section.userTasks': 'User tasks',
  'usage.section.documents': 'Documents & storage',
  'usage.section.documents.subtitle': 'Keep plan stock separate from filtered documents',
  'usage.section.emails': 'Emails',
  'usage.section.ai': 'AI consumption',
  'usage.section.ai.subtitle': 'Tokens, price, ledger and credits (do not conflate metrics)',
  'usage.section.aiAgents': 'AI agents',
  'usage.section.rpa': 'RPA agents',
  'usage.section.rpa.subtitle': 'Separate domain — AI agent filter does not apply',
  'usage.section.organization': 'Organization',
  'usage.section.organization.subtitle': 'Company inventory / stock',
  'usage.section.aux': 'Auxiliary sections',
  'usage.section.loadMore': 'Load section',
  'usage.section.retry': 'Retry',

  'usage.status.execution': 'In execution',
  'usage.status.approved': 'Approved',
  'usage.status.rejected': 'Rejected',
  'usage.status.canceled': 'Canceled',
  'usage.status.voided': 'Voided',
  'usage.status.error': 'Error',
  'usage.status.unknown': '{status}',

  'usage.requests.total': 'Total',
  'usage.requests.byStatus': 'By status',
  'usage.requests.byProcess': 'Top by process',

  'usage.bulk.totalTasks': 'Bulk tasks',
  'usage.bulk.totalRequested': 'Requested instances',
  'usage.bulk.items': 'Items',
  'usage.bulk.successful': 'Successful',
  'usage.bulk.failed': 'Failed',

  'usage.tasks.total': 'Total tasks',
  'usage.tasks.finished': 'Finished in period',
  'usage.tasks.overdue': 'Overdue open',
  'usage.tasks.overdueHint': 'Open overdue stock — date filters do not apply',
  'usage.tasks.byType': 'By type',

  'usage.docs.total': 'Documents',
  'usage.docs.bySource': 'By source',
  'usage.storage.planUsed': 'Plan usage (snapshot)',
  'usage.storage.planLimit': 'Plan limit',
  'usage.storage.planPercent': '% of plan',
  'usage.storage.docsStock': 'Documents stock (filtered)',
  'usage.storage.docsAdded': 'Added in period',
  'usage.storage.planHint': 'Plan % uses only planUsed / planLimit, not filtered document stock.',

  'usage.emails.planConsumption': 'Plan consumption',
  'usage.emails.planLimit': 'Plan limit',
  'usage.emails.traced': 'Traced attempts',
  'usage.emails.succeeded': 'Succeeded',
  'usage.emails.failed': 'Failed',
  'usage.emails.hint': 'Plan consumption and traces are not expected to match.',

  'usage.ai.finalPrice': 'FinalPrice',
  'usage.ai.planAllocation': 'Plan allocation',
  'usage.ai.creditsAvailable': 'Credits available (period)',
  'usage.ai.creditsAssigned': 'Credits assigned (stock)',
  'usage.ai.inputTokens': 'Input tokens',
  'usage.ai.inputCache': 'Cache tokens',
  'usage.ai.outputTokens': 'Output tokens',
  'usage.ai.totalTokens': 'Total tokens',
  'usage.ai.byModel': 'By model',
  'usage.ai.ledger': 'Billing ledger',
  'usage.ai.ledgerConsumed': 'Ledger consumed',
  'usage.ai.ledgerEntries': 'Ledger entries',
  'usage.ai.ledgerHint': 'FinalPrice ≠ ledger ≠ credits. Separate metrics.',
  'usage.ai.cta': 'View consumption detail',
  'usage.ai.creditApplied': 'Credit Applied',

  'usage.agents.total': 'Agents',
  'usage.agents.active': 'Active',
  'usage.agents.schedules': 'Schedules',
  'usage.agents.executions': 'Executions (jobs)',
  'usage.agents.succeeded': 'Jobs OK',
  'usage.agents.failed': 'Failed jobs',
  'usage.agents.threads': 'Threads created',
  'usage.agents.hint': 'Jobs ≠ threads ≠ model calls ≠ ledger entries.',

  'usage.rpa.agents': 'RPA agents',
  'usage.rpa.flows': 'Flows',
  'usage.rpa.instances': 'Instances',
  'usage.rpa.active': 'Active',

  'usage.org.users': 'Users',
  'usage.org.entities': 'Dynamic entities',
  'usage.org.lists': 'Custom lists',
  'usage.org.positions': 'Positions',
  'usage.org.areas': 'Areas',
  'usage.org.groups': 'User groups',
  'usage.org.active': 'Active',
  'usage.org.total': 'Total',
  'usage.org.planLimit': 'Plan limit',

  'usage.empty': 'No data for the selected filters',
  'usage.loading': 'Loading…',
  'usage.error': 'Could not load this section',
};
